import axiosInstance from "../lib/axiosInstance";

export const generateOtp = async (mobileOrEmail) => {
    const response = await axiosInstance.post(
        "/student/login/generate-otp",
        {
            mobileOrEmail: mobileOrEmail,
        }
    );
    return response.data;
};
export const verifyOtp = async (mobileOrEmail, otp) => {
    const response = await axiosInstance.post(
        "/student/login/verify-otp",
        {
            mobileOrEmail,
            otp,
        }
    );
    return response.data;
};
export const saveFcmToken = async (fcmToken) => {
    try {
        const response = await axiosInstance.post(
            "/common/device/addDevice",
            { deviceToken: fcmToken }
        );
        return response.data;
    } catch (err) {
        console.error("Error saving FCM token:", err);
        return null;
    }
};
export const getNotifications = async () => {
    try {
        const res = await axiosInstance.post("/common/notification/getAllNotifications");
        return res.data;
    } catch (err) {
        console.error("Failed to fetch notifications", err);
        return null;
    }
};

export const clearNotifications = async (notificationUuid = null, readAll = false) => {
  try {
    const payload = readAll
      ? { readAll: true } 
      : { notificationUuid, readAll: false }; 

    const res = await axiosInstance.post(
      "/common/notification/readNotifications",
      payload
    );

    return res.data;
  } catch (err) {
    console.error("Failed to clear notifications", err);
    return null;
  }
};

export const logout = async () => {
    try {
        const response = await axiosInstance.post("/api/student/profile/logout");
        return response.data;
    } catch (err) {
        console.error("Error during logout:", err);
        return null;
    }
};
